module.exports = __webpack_public_path__ + "img/full-00.8927b398.png";